export var COMPONENT_NAME = 'SoothingSerenity';